export { ConfirmAmendmentChange } from './ConfirmAmendmentChange.modal'
